function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnInternalheating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 160",
    d: "M21.93 8.56a.47.47 0 1 1-.66.66l-.81-.8v5.38a.46.46 0 1 1-.92 0V8.42l-.81.8a.47.47 0 1 1-.66-.66L19.67 7a.53.53 0 0 1 .15-.11.47.47 0 0 1 .17 0 .47.47 0 0 1 .17 0 .53.53 0 0 1 .15.11l1.6 1.59m-11.36 4.69a.47.47 0 0 0 .93 0v-1.14L15.29 16a.47.47 0 0 0 .66-.66l-3.81-3.81h1.14a.47.47 0 0 0 0-.93H11a.47.47 0 0 0-.17 0 .39.39 0 0 0-.25.25.47.47 0 0 0 0 .17zm.47 13a.47.47 0 0 0-.47.46V29a.47.47 0 0 0 0 .17.31.31 0 0 0 .1.15.31.31 0 0 0 .15.1.47.47 0 0 0 .17 0h2.26a.47.47 0 0 0 0-.93h-1.09L16 24.71a.47.47 0 0 0-.66-.66l-3.81 3.81v-1.14a.47.47 0 0 0-.53-.46zm8.72 6.83h.36l.07-.06 1.6-1.59a.47.47 0 1 0-.66-.66l-.81.8v-5.4a.46.46 0 0 0-.92 0v5.38l-.81-.8a.47.47 0 1 0-.66.66L19.67 33l.07.06m9.26-6.8a.47.47 0 0 0-.46.46v1.14l-3.81-3.81a.47.47 0 0 0-.66.66l3.81 3.81h-1.16a.47.47 0 0 0 0 .93H29a.47.47 0 0 0 .17 0 .31.31 0 0 0 .15-.1.31.31 0 0 0 .1-.15.47.47 0 0 0 0-.17v-2.31a.47.47 0 0 0-.42-.46zM29.45 11a.47.47 0 0 0 0-.17.39.39 0 0 0-.25-.25.47.47 0 0 0-.17 0h-2.31a.47.47 0 0 0 0 .93h1.14l-3.81 3.81a.47.47 0 0 0 .66.66l3.81-3.81v1.14a.47.47 0 0 0 .93 0V11zM36 20a16 16 0 1 0-16 16 16 16 0 0 0 16-16zm-.86 0A15.14 15.14 0 1 1 20 4.86 15.14 15.14 0 0 1 35.14 20zM19 18.78a1.56 1.56 0 0 1 1.92 0h1.38A2.62 2.62 0 0 0 20 17.4a2.59 2.59 0 0 0-2.29 1.38zm2 2.44a1.56 1.56 0 0 1-1.92 0h-1.37A2.59 2.59 0 0 0 20 22.6a2.62 2.62 0 0 0 2.3-1.38zM30.35 20a.64.64 0 0 0-.64-.64H10.29a.64.64 0 1 0 0 1.28h19.42a.64.64 0 0 0 .64-.64z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInternalheating);
export default __webpack_public_path__ + "static/media/icn-internalheating.7deade5bd09040dbbbf8cdfd7cc09e94.svg";
export { ForwardRef as ReactComponent };